import { gql } from '@apollo/client';

export const getOperation = gql`
  query getOperation($operationId: String!, $companyId: String!) {
    session: getSession(sessionId: $operationId, companyId: $companyId) {
      alerts {
        risk
        type
        view
      }
      devices {
        id
        family
        model
        cbf
        timezone
        diskSpace
        androidId
        operationSystem {
          version
          family
          language
        }
        screen {
          density
          orientation
          resolution
          size
        }
      }
      networks {
        geolocation {
          city
          country
          region
        }
        ip
        isp
        type
      }
      sessionId
      company
      userId
      registerDate
      score
      source
    }
  }
`;

export const getOperations = gql`
  subscription getOperations($companyId: String!, $search: SearchSessionInput) {
    session: getSessions(companyId: $companyId, search: $search) {
      alerts {
        risk
        type
        view
      }
      devices {
        id
        family
        model
        cbf
        timezone
        diskSpace
        androidId
        operationSystem {
          version
          family
          language
        }
        screen {
          density
          orientation
          resolution
          size
        }
      }
      networks {
        geolocation {
          city
          country
          region
        }
        ip
        isp
        type
      }
      sessionId
      company
      userId
      registerDate
      score
      source
    }
  }
`;
